import styled from 'styled-components';

const HouseSmartMobileNavStyles = styled.section`
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 75px;
  z-index: 9;

  .active-bar {
    background: #ef4b5d;
    position: absolute;
    bottom: calc(100% + 3px);
    height: 75px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: white;
  }
  .mobile-navbar {
    display: flex;
    width: 100%;
    list-style: none;
    height: 100%;
    cursor: pointer;
    li {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      &:after {
        content: '';
        top: -3px;
        width: 100%;
        background: transparent;
        height: 3px;
        position: absolute;
      }
      &:nth-child(1) {
        background: #ef4b5d;
      }
      &:nth-child(2) {
        background: #352269;
      }
      &:nth-child(3) {
        background: #00b0ac;
      }
      &:nth-child(4) {
        background: #ffc50a;
      }
    }
    .white-li {
      &:after {
        background: #fff;
      }
    }
    .active-red {
      &:after {
        background: #ef4b5d;
      }
    }
    .active-purple {
      &:after {
        background: #352269;
      }
    }
    .active-teal {
      &:after {
        background: #00b0ac;
      }
    }
    .active-yellow {
      &:after {
        background: #ffc50a;
      }
    }
  }
  .active-bar.active {
    display: flex;
  }
  .active-bar.inactive {
    display: none;
  }
`;

export default HouseSmartMobileNavStyles;
